export { BRAND_PRIMARY_HEX } from "@shared/constants/brand";

import {
  DEFAULT_EMPLOYEE_CURRENCY,
  EMPLOYEE_CURRENCIES,
  isEmployeeCurrency,
} from "@shared/constants/currency";

export { getCurrencyLabel } from "@shared/constants/currency";
export { EMPLOYEE_CURRENCIES };

export const JOB_LEVELS = [
  { value: "L0_IC", label: "L0 - IC" },
  { value: "L1_IC", label: "L1 - IC" },
  { value: "L2_IC", label: "L2 - IC" },
  { value: "L3_IC", label: "L3 - IC" },
  { value: "L3_MGMT", label: "L3 - MGMT" },
  { value: "L4_IC", label: "L4 - IC" },
  { value: "L4_MGMT", label: "L4 - MGMT" },
  { value: "L5_IC", label: "L5 - IC" },
  { value: "L5_MGMT", label: "L5 - MGMT" },
  { value: "L6_IC", label: "L6 - IC" },
  { value: "L6_MGMT", label: "L6 - MGMT" },
  { value: "L7_IC", label: "L7 - IC" },
  { value: "L7_MGMT", label: "L7 - MGMT" },
  { value: "L8_IC", label: "L8 - IC" },
  { value: "L8_MGMT", label: "L8 - MGMT" },
  { value: "L9_IC", label: "L9 - IC" },
  { value: "L9_MGMT", label: "L9 - MGMT" },
] as const;

export const COMP_DISCIPLINES = [
  { value: "account_management", label: "Account Management (AM)" },
  { value: "accounting", label: "Accounting" },
  { value: "accounts_payable_receivable", label: "Accounts Payable/Receivable" },
  { value: "administration_generalist", label: "Administration Generalist" },
  { value: "ai_machine_learning", label: "AI & Machine Learning" },
  { value: "analytics_engineering", label: "Analytics Engineering" },
  { value: "audio_and_video", label: "Audio and Video" },
  { value: "b2b_sales_executive", label: "B2B Sales Executive" },
  { value: "brand_marketing", label: "Brand Marketing" },
  { value: "business_analysis", label: "Business Analysis" },
  { value: "business_development", label: "Business Development (BizDev)" },
  { value: "business_operations", label: "Business Operations" },
  { value: "ceo", label: "CEO" },
  { value: "cloud_computing_architecture", label: "Cloud Computing Architecture" },
  { value: "communications_pr_marketing", label: "Communications and PR Marketing" },
  { value: "compensation_benefits", label: "Compensation & Benefits" },
  { value: "compliance", label: "Compliance" },
  { value: "content_marketing", label: "Content Marketing" },
  { value: "continuous_improvement", label: "Continuous Improvement" },
  { value: "controllership", label: "Controllership" },
  { value: "copywriter", label: "Copywriter" },
  { value: "credit_collection", label: "Credit Collection" },
  { value: "credit_risk", label: "Credit Risk" },
  { value: "crm", label: "CRM" },
  { value: "customer_experience_generalist", label: "Customer Experience Generalist" },
  { value: "customer_success", label: "Customer Success" },
  { value: "customer_support", label: "Customer Support" },
  { value: "data_analysis", label: "Data Analysis" },
  { value: "dba", label: "Data Base Administrador (DBA)" },
  { value: "data_engineering", label: "Data Engineering" },
  { value: "data_governance", label: "Data Governance" },
  { value: "data_science", label: "Data Science" },
  { value: "devops_engineering", label: "DevOps Engineering" },
  { value: "esg_generalist", label: "ESG Generalist" },
  { value: "events_community_management", label: "Events and Community Management" },
  { value: "executive_secretary", label: "Executive Secretary" },
  { value: "finance_generalist", label: "Finance Generalist" },
  { value: "fpa", label: "Financial Planning and Analysis (FP&A)" },
  { value: "fraud_prevention", label: "Fraud Prevention" },
  { value: "general_manager", label: "General Manager" },
  { value: "general_services", label: "General Services" },
  { value: "governance_internal_controls", label: "Governance & Internal Controls" },
  { value: "graphic_design", label: "Graphic Design" },
  { value: "growth_marketing", label: "Growth Marketing" },
  { value: "hrbp", label: "HR Business Partner (HRBP)" },
  { value: "hr_generalist", label: "HR Generalist" },
  { value: "hr_operations_payroll", label: "HR Operations & Payroll" },
  { value: "import_export_generalist", label: "Import/Export Generalist" },
  { value: "information_security", label: "Information Security" },
  { value: "it_support", label: "Information Technology Support" },
  { value: "internal_auditing", label: "Internal Auditing" },
  {
    value: "internal_communication_employer_branding",
    label: "Internal Communication & Employer Branding",
  },
  { value: "it_quality_assurance", label: "IT Quality Assurance" },
  { value: "it_systems_infrastructure", label: "IT Systems and Infrastructure" },
  { value: "learning_development", label: "Learning & Development" },
  { value: "legal_generalist", label: "Legal Generalist" },
  { value: "legal_support", label: "Legal Support" },
  { value: "logistic_management_generalist", label: "Logistic Management Generalist" },
  { value: "market_intelligence", label: "Market Intelligence" },
  { value: "marketing_generalist", label: "Marketing Generalist" },
  { value: "merger_acquisition", label: "Merger and Acquisition (M&A)" },
  { value: "nurse_practitioner", label: "Nurse Practitioner" },
  { value: "occupational_health_nurse", label: "Occupational Health Nurse" },
  { value: "occupational_safety", label: "Occupational Safety" },
  { value: "office_management_facilities", label: "Office Management and Facilities" },
  { value: "operational_risk_management", label: "Operational Risk Management" },
  { value: "performance_marketing", label: "Performance Marketing" },
  { value: "pricing", label: "Pricing" },
  { value: "procurement_generalist", label: "Procurement Generalist" },
  { value: "product_design", label: "Product Design" },
  { value: "product_management", label: "Product Management" },
  { value: "product_marketing", label: "Product Marketing" },
  { value: "project_management_generalist", label: "Project Management Generalist" },
  { value: "quality_assurance", label: "Quality Assurance" },
  { value: "retail_sales", label: "Retail Sales" },
  { value: "revenue_sales_operations", label: "Revenue/Sales Operations" },
  { value: "risk_compliance_generalist", label: "Risk & Compliance Generalist" },
  { value: "sales_efficiency_enablement", label: "Sales Efficiency and Enablement" },
  { value: "sales_generalist", label: "Sales Generalist" },
  { value: "scrum_master", label: "Scrum Master" },
  { value: "sdr", label: "SDR" },
  { value: "seo", label: "Search Engine Optimization (SEO)" },
  { value: "sre", label: "Site Reliability Engineer (SRE)" },
  { value: "social_media", label: "Social Media" },
  { value: "software_engineering", label: "Software Engineering" },
  { value: "strategic_planning", label: "Strategic Planning" },
  { value: "systems_architecture", label: "Systems Architecture" },
  { value: "talent_acquisition", label: "Talent Acquisition" },
  { value: "tax_fiscal", label: "Tax & Fiscal" },
  { value: "technical_customer_support", label: "Technical Customer Support" },
  { value: "technical_integration", label: "Technical Integration" },
  { value: "technical_sales", label: "Technical Sales" },
  { value: "test_automation_engineering", label: "Test Automation Engineering" },
  { value: "treasury", label: "Treasury" },
  { value: "ux_ui_research", label: "UX/UI Research" },
  { value: "warehouse", label: "Warehouse" },
] as const;

export const DEPARTMENTS = [
  { value: "growth", label: "Growth" },
  { value: "sales", label: "Sales" },
  { value: "engineering", label: "Engenharia" },
  { value: "product", label: "Produto" },
  { value: "data_science", label: "Data Science" },
  { value: "design", label: "Design" },
  { value: "client_partner", label: "Client Partner" },
  { value: "comp_exec", label: "Comp Exec" },
  { value: "backoffice", label: "Backoffice" },
] as const;

export const EMPLOYMENT_TYPES = [
  { value: "CLT", label: "CLT" },
  { value: "PJ", label: "PJ" },
] as const;

export const WORK_TYPES = [
  { value: "remote", label: "Remote" },
  { value: "hybrid", label: "Hybrid" },
  { value: "onsite", label: "On-site" },
] as const;

export const EMPLOYEE_STATUSES = [
  { value: "onboarding", label: "Onboarding" },
  { value: "active", label: "Ativo" },
  { value: "inactive", label: "Inativo" },
] as const;

export const APPLICATION_TYPES = [
  { value: "organic", label: "Orgânico" },
  { value: "referral", label: "Indicação" },
  { value: "hunting_comp", label: "Hunting Comp" },
  { value: "consultoria", label: "Consultoria" },
] as const;

export const PERFORMANCE_RATINGS = [
  { value: "meets", label: "Meets Expectations" },
  { value: "doesnt_meet", label: "Doesn't Meet Expectations" },
] as const;

/**
 * Formats a monetary value. `currency` accepts any supported employee currency
 * code (BRL, USD); unknown/absent values fall back to BRL so existing callers
 * keep their previous behavior.
 */
export const formatCurrency = (
  value: string | number | null | undefined,
  currency?: string | null,
): string => {
  const code = isEmployeeCurrency(currency) ? currency : DEFAULT_EMPLOYEE_CURRENCY;
  const locale = EMPLOYEE_CURRENCIES.find((c) => c.value === code)?.locale ?? "pt-BR";
  const num =
    value === null || value === undefined
      ? 0
      : typeof value === "string"
        ? parseFloat(value)
        : value;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: code,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Number.isNaN(num) ? 0 : num);
};

export const formatSharesRange = (shares: number, maxShares?: number | null): string => {
  const base = shares.toLocaleString("pt-BR");
  if (maxShares) {
    return `${base} – ${maxShares.toLocaleString("pt-BR")} ações`;
  }
  return `${base} ações`;
};

/** Parse a date string safely. Date-only strings (YYYY-MM-DD) are interpreted as
 *  UTC midnight by JS, which shifts to the previous day in negative-UTC timezones.
 *  Appending T12:00:00 forces local-time parsing at noon, safe for any timezone. */
export const parseLocalDate = (date: string | Date): Date => {
  if (date instanceof Date) return date;
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return new Date(`${date}T12:00:00`);
  return new Date(date);
};

export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) return "-";
  return parseLocalDate(date).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatDateTime = (date: string | Date | null | undefined): string => {
  if (!date) return "-";
  return parseLocalDate(date).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getDepartmentLabel = (value: string | null | undefined): string => {
  if (!value) return "-";
  const dept = DEPARTMENTS.find((d) => d.value === value);
  return dept?.label || value;
};

export const getJobLevelLabel = (value: string | null | undefined): string => {
  if (!value) return "-";
  const level = JOB_LEVELS.find((l) => l.value === value);
  return level?.label || value;
};

export const getOptionLabel = (
  options: readonly { value: string; label: string }[],
  value: string | null | undefined,
): string => {
  if (!value) return "-";
  return options.find((o) => o.value === value)?.label || value;
};

export const getWorkTypeLabel = (value: string | null | undefined): string =>
  getOptionLabel(WORK_TYPES, value);
export const getEmploymentTypeLabel = (value: string | null | undefined): string =>
  getOptionLabel(EMPLOYMENT_TYPES, value);
export const getStatusLabel = (value: string | null | undefined): string =>
  getOptionLabel(EMPLOYEE_STATUSES, value);
export const getCompDisciplineLabel = (value: string | null | undefined): string =>
  getOptionLabel(COMP_DISCIPLINES, value);

type DepartmentKey = (typeof DEPARTMENTS)[number]["value"];

export const DEPARTMENT_STYLES: Record<DepartmentKey, { icon: string; bg: string; text: string }> =
  {
    engineering: {
      icon: "Code",
      bg: "bg-emerald-100 dark:bg-emerald-900/30",
      text: "text-emerald-600 dark:text-emerald-400",
    },
    growth: {
      icon: "TrendingUp",
      bg: "bg-blue-100 dark:bg-blue-900/30",
      text: "text-blue-600 dark:text-blue-400",
    },
    sales: {
      icon: "BarChart3",
      bg: "bg-green-100 dark:bg-green-900/30",
      text: "text-green-600 dark:text-green-400",
    },
    product: {
      icon: "Box",
      bg: "bg-violet-100 dark:bg-violet-900/30",
      text: "text-violet-600 dark:text-violet-400",
    },
    data_science: {
      icon: "Database",
      bg: "bg-cyan-100 dark:bg-cyan-900/30",
      text: "text-cyan-600 dark:text-cyan-400",
    },
    design: {
      icon: "Palette",
      bg: "bg-pink-100 dark:bg-pink-900/30",
      text: "text-pink-600 dark:text-pink-400",
    },
    client_partner: {
      icon: "Handshake",
      bg: "bg-indigo-100 dark:bg-indigo-900/30",
      text: "text-indigo-600 dark:text-indigo-400",
    },
    comp_exec: {
      icon: "Shield",
      bg: "bg-red-100 dark:bg-red-900/30",
      text: "text-red-600 dark:text-red-400",
    },
    backoffice: {
      icon: "Settings",
      bg: "bg-slate-100 dark:bg-slate-800",
      text: "text-slate-600 dark:text-slate-400",
    },
  };
